import request from '@/utils/request'

const baseUrlHikeDpZhihuishu = 'https://hike-dp.zhihuishu.com/screenThemeData/common/api'

// 教学资源统计
const getTeachRecourse = (params) => {
    return request({
        baseURL: baseUrlHikeDpZhihuishu,
        url: `/2-1/getTeachingResourceStatistics`,
        method: 'get',
        params
    })
}

// 今日课堂数据汇总
const getTodayClass = (params) => {
    return request({
        baseURL: baseUrlHikeDpZhihuishu,
        url: '/2-1/todayClassroomSummary',
        method: 'get',
        params
    })
}

// 课堂互动统计
const getTeachInteraction = (params) => {
    return request({
        baseURL: baseUrlHikeDpZhihuishu,
        url: '/2-1/getCourseInteractionStatistics',
        method: 'get',
        params
    })
}

// 中间课堂互动资源数
const getMiddleScreenData = (params) => {
    return request({
        baseURL: baseUrlHikeDpZhihuishu,
        url: '/2-1/findMediumScreenDate',
        method: 'get',
        params
    })
}

// 校区及教室数量
const getClassroomData = (params) => {
    return request({
        baseURL: baseUrlHikeDpZhihuishu,
        url: '/2-1/getClassroomData',
        method: 'get',
        params
    })
}

// 在线师生总人数
const getOnlinePeopleCount = (params) => {
    return request({
        baseURL: baseUrlHikeDpZhihuishu,
        url: '/2-1/findOnlinePeopleCount',
        method: 'get',
        params
    })
}

export default {
    getTeachRecourse,
    getTodayClass,
    getTeachInteraction,
    getMiddleScreenData,
    getClassroomData,
    getOnlinePeopleCount
}